// Wrapper module for moment with business days extension
// Manually extend moment with business days methods to avoid CommonJS interop issues
import moment from 'moment'

// Copy the business day methods from moment-business-days source
// This avoids the CommonJS require() issues with Vite
moment.fn.isHoliday = function() {
  var locale = this.localeData()

  if (locale._holidays) {
    if (locale._holidays.indexOf(this.format(locale._holidayFormat)) >= 0) { return true }
  }

  if (locale.holiday) {
    if (locale.holiday(this)) {
      return true
    }
    return false
  }

  return false
}

moment.fn.isBusinessDay = function() {
  var locale = this.localeData()
  var defaultWorkingWeekdays = [1, 2, 3, 4, 5]
  var workingWeekdays = locale._workingWeekdays || defaultWorkingWeekdays

  if (this.isHoliday()) { return false }
  if (workingWeekdays.indexOf(this.day()) >= 0) { return true }

  return false
}

moment.fn.businessDaysIntoMonth = function() {
  if (!this.isValid()) {
    return NaN
  }
  var businessDay = this.isBusinessDay() ? this : this.prevBusinessDay()
  var monthBusinessDays = businessDay.monthBusinessDays()
  var businessDaysIntoMonth
  monthBusinessDays.map(function(day, index) {
    if (day.format('M/DD/YY') === businessDay.format('M/DD/YY')) {
      businessDaysIntoMonth = index + 1
    }
  })
  return businessDaysIntoMonth
}

moment.fn.businessAdd = function(number, period) {
  var day = this.clone()
  if (!this.isValid()) {
    return day
  }
  if (!period || period === 'days' || period === 'd') {
    var signal = number < 0 ? -1 : 1
    var remaining = Math.abs(number)
    while (remaining > 0) {
      day.add(signal, 'd')
      if (day.isBusinessDay()) {
        remaining--
      }
    }
  } else {
    day.add(number, period)
  }
  return day
}

moment.fn.businessSubtract = function(number, period) {
  return this.businessAdd(-number, period)
}

moment.fn.businessDiff = function(comparator, period, float) {
  var day = this.clone()
  var comp = moment(comparator)
  var signal = day.isAfter(comp) ? -1 : 1
  var result = 0
  if (!this.isValid()) {
    return NaN
  }
  if (!period || period === 'days' || period === 'd') {
    while (!day.isSame(comp, 'd')) {
      if (day.isBusinessDay()) {
        result++
      }
      day.add(signal, 'd')
    }
  } else {
    result = day.diff(comparator, period, float)
  }
  return result
}

moment.fn.nextBusinessDay = function() {
  var day = this.clone()
  day.add(1, 'd')
  while (!day.isBusinessDay()) {
    day.add(1, 'd')
  }
  return day
}

moment.fn.prevBusinessDay = function() {
  var day = this.clone()
  day.subtract(1, 'd')
  while (!day.isBusinessDay()) {
    day.subtract(1, 'd')
  }
  return day
}

moment.fn.monthBusinessDays = function(partialEndDate) {
  if (!this.isValid()) {
    return []
  }
  var day = this.clone().startOf('month')
  var end = partialEndDate ? this.clone() : this.clone().endOf('month')
  var result = []
  while (day.isBefore(end, 'd') || day.isSame(end, 'd')) {
    if (day.isBusinessDay()) {
      result.push(day.clone())
    }
    day.add(1, 'd')
  }
  return result
}

moment.fn.monthNaturalDays = function(fromToday) {
  if (!this.isValid()) {
    return []
  }
  var day = fromToday ? this.clone() : this.clone().startOf('month')
  var end = this.clone().endOf('month')
  var result = []
  while (day.isBefore(end, 'd') || day.isSame(end, 'd')) {
    result.push(day.clone())
    day.add(1, 'd')
  }
  return result
}

moment.fn.monthNaturalWeeks = function(fromToday) {
  var day = fromToday ? this.clone() : this.clone().startOf('month')
  var end = this.clone().endOf('month')
  var locale = this.localeData()
  var result = []
  var week = []
  var fdow = locale._week ? locale._week.dow : 0
  while (day.isBefore(end, 'd') || day.isSame(end, 'd')) {
    week.push(day.clone())
    if (day.day() === (fdow + 6) % 7) {
      result.push(week)
      week = []
    }
    day.add(1, 'd')
  }
  if (week.length) {
    result.push(week)
  }
  return result
}

moment.fn.monthBusinessWeeks = function(fromToday) {
  var weeks = this.monthNaturalWeeks(fromToday)
  var result = []
  weeks.forEach(function(week) {
    var businessWeek = week.filter(function(day) {
      return day.isBusinessDay()
    })
    if (businessWeek.length) {
      result.push(businessWeek)
    }
  })
  return result
}

export default moment
export { moment }
